import { createContext, useContext } from "react";
import { Close } from "@common/schemas/close.schema";

const NO_CLIENT_NAMES = new Map<string, string>();

export const TaskClientNamesContext =
    createContext<ReadonlyMap<string, string>>(NO_CLIENT_NAMES);

const NO_CLIENT_ICON_COLORS = new Map<string, string | null>();

export const TaskClientIconColorsContext = createContext<
    ReadonlyMap<string, string | null>
>(NO_CLIENT_ICON_COLORS);

export const useTaskClientIconColor = (workspaceId: string | undefined) => {
    const iconColorsById = useContext(TaskClientIconColorsContext);
    return workspaceId ? (iconColorsById.get(workspaceId) ?? null) : null;
};

export const useTaskClientName = (workspaceId: string | undefined) => {
    const clientNamesById = useContext(TaskClientNamesContext);
    return workspaceId ? clientNamesById.get(workspaceId) : undefined;
};

export const getCloseClientName = (
    close: Pick<Close, "workspaceId">,
    clientNamesById: ReadonlyMap<string, string>,
) => (close.workspaceId ? clientNamesById.get(close.workspaceId) : undefined);
